import SvgIcon from "./svg-icon";
export default SvgIcon;
